import React, { useEffect, useState } from 'react'
import { 
    Box, 
    Typography, 
    CardMedia,
    Grid
} from '@mui/material'
import { useLocation} from "react-router-dom";
import * as api from '../../api/Paid'
import failLogo from '../../assets/images/logo/cross.png'
export const ResultFailed = () => {
    const location = useLocation()
    const [statusDesc, setStatusDesc] = useState('')

    const getPaymentStatus = async () => {
        let params = new URLSearchParams(location.search);
        const transactionId = params.get("transactionId")

        if (transactionId) {
            const res = await api.getPaymentMpayStatus({
                txn_id: transactionId
            })
            if (res.status === 200) {
                const data = res.data.data
                setStatusDesc(data.status_message)
            }
        }
    }

    useEffect(() => {
        getPaymentStatus()
    }, [])

    return (
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "70vh", p: 5 }}>
            <Grid container direction={"column"} justifyContent="center" alignItems="center" >
                <CardMedia
                    component="img"
                    sx={{ width: "50%" }}
                    src={failLogo}
                />
                <Typography>การชำระเงินไม่สำเร็จ</Typography>
                <Typography>Payment unsuccessful</Typography>
                <Typography>{statusDesc}</Typography>

            </Grid>

        </Box>
    )
}
